import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Mail } from "lucide-react";

const FAQ = [
  {
    q: "How are my royalties calculated?",
    a: "You earn 95% of the net publisher compensation paid to Healing House by IngramSpark for every sale of your book. Publisher retains 5%. Net publisher compensation is the wholesale price received by the publisher after IngramSpark's print, distribution and platform fees — it is the actual money landed in our account, not the cover price.",
  },
  {
    q: "When am I paid?",
    a: "Royalties are paid quarterly. Q1 covers Jan–Mar, Q2 covers Apr–Jun, Q3 covers Jul–Sep, Q4 covers Oct–Dec. Each quarter falls due at the end of the following quarter and is paid within 30 days after that — Q1 (Jan–Mar) is paid by 31 July, Q2 (Apr–Jun) by 31 October, Q3 (Jul–Sep) by 31 January and Q4 (Oct–Dec) by 30 April.",
  },
  {
    q: "Why are amounts shown in multiple currencies?",
    a: "IngramSpark reports compensation in the currency of the buying market — AUD for Australian print sales, USD for US sales, GBP for UK sales. We pay you in AUD, converting foreign-currency earnings at the spot rate on the payment date.",
  },
  {
    q: "What if my dashboard data looks wrong?",
    a: "Please send your publisher a note via the Contact button below. We re-ingest IngramSpark reports monthly — if you spot a discrepancy, we can check the raw report and reconcile.",
  },
  {
    q: "Can I download my royalty statement as a PDF?",
    a: "Yes — every closed quarterly cycle generates a downloadable PDF statement in your Statements & Payments tab. Your current (live) cycle is visible there too.",
  },
  {
    q: "How often does the data update?",
    a: "We upload the previous month's IngramSpark reports once they're released (usually the first week of every month). Your numbers reflect everything reported up to that date.",
  },
];

export default function Contact() {
  return (
    <div className="space-y-16" data-testid="contact-page">
      <header>
        <p className="hh-overline mb-3">Contact</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-hh-ink tracking-tight">
          Anything you need — you know where to find me.
        </h1>
      </header>

      <section className="hh-card p-8 md:p-12 flex flex-col md:flex-row gap-6 items-start md:items-center">
        <span className="h-14 w-14 rounded-full bg-hh-muted grid place-items-center shrink-0">
          <Mail size={20} strokeWidth={1.5} className="text-hh-primary" />
        </span>
        <div className="flex-1">
          <h3 className="font-serif text-2xl text-hh-ink">Email your publisher</h3>
          <p className="mt-2 text-hh-ink2">Most queries answered the same day. Send a screenshot if it helps.</p>
        </div>
        <a href="mailto:support@thebookdoula.com.au" className="hh-btn-primary" data-testid="contact-email-button">
          support@thebookdoula.com.au
        </a>
      </section>

      <section data-testid="faq-section">
        <p className="hh-overline mb-6">Frequently asked</p>
        <div className="hh-card p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f) => (
              <AccordionItem key={f.q} value={f.q} data-testid={`faq-${f.q.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 30)}`}>
                <AccordionTrigger className="font-serif text-lg text-hh-ink text-left hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-hh-ink2 leading-relaxed text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
